import dayjs from 'dayjs';

const triggerCSVDownload = (headers, rows, filename) => {
  const csvContent = [
    headers.join(','),
    ...rows.map((row) =>
      row.map((cell) => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(','),
    ),
  ].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

export const downloadForecastCSV = ({ view, formattedProjects, filtersRange, companiesMap }) => {
  if (view === 'project') {
    const headers = [
      'ID',
      'Project Name',
      'Client',
      'Project Lead',
      'State',
      'Probability',
      ...filtersRange,
      'Total',
    ];
    const rows = formattedProjects.map((project) => {
      const monthValues = filtersRange.map((month) => {
        const val = project.formattedSchedule.find((x) => x.date === month)?.value || 0;
        return parseFloat(val).toFixed(2);
      });
      const total = filtersRange.reduce((sum, month) => {
        const val = project.formattedSchedule.find((x) => x.date === month)?.value || 0;
        return sum + parseFloat(val);
      }, 0);
      return [
        project.id,
        project.projectName,
        companiesMap[project.client] || '',
        project.projectLead || project.lead || '',
        project.state,
        project.probability ? `${project.probability}%` : '',
        ...monthValues,
        total.toFixed(2),
      ];
    });
    const monthTotals = filtersRange.map((month) =>
      formattedProjects
        .reduce((sum, p) => {
          const val = p.formattedSchedule.find((x) => x.date === month)?.value || 0;
          return sum + parseFloat(val);
        }, 0)
        .toFixed(2),
    );
    const grandTotal = monthTotals.reduce((sum, v) => sum + parseFloat(v), 0).toFixed(2);
    rows.push(['', 'Totals', '', '', '', '', ...monthTotals, grandTotal]);
    triggerCSVDownload(
      headers,
      rows,
      `revenue-forecast-projects-${dayjs().format('YYYY-MM-DD')}.csv`,
    );
  } else {
    const clientsSum = formattedProjects.reduce((acc, project) => {
      if (!acc[project.client]) {
        acc[project.client] = filtersRange.reduce((a, month) => ({ ...a, [month]: 0 }), {});
      }
      project.formattedSchedule.forEach((item) => {
        if (filtersRange.includes(item.date)) {
          acc[project.client][item.date] += item.value;
        }
      });
      return acc;
    }, {});
    const dataToRender = Object.keys(clientsSum).map((id) => ({
      id,
      clientName: companiesMap[id] || '',
      schedule: clientsSum[id],
      clientTotal: Object.values(clientsSum[id]).reduce((sum, v) => sum + v, 0),
    }));
    const headers = ['ID', 'Client', ...filtersRange, 'Total'];
    const rows = dataToRender.map((client) => {
      const monthValues = filtersRange.map((month) =>
        (client.schedule[month] || 0).toFixed(2),
      );
      return [client.id, client.clientName, ...monthValues, client.clientTotal.toFixed(2)];
    });
    const monthTotals = filtersRange.map((month) =>
      dataToRender.reduce((sum, c) => sum + (c.schedule[month] || 0), 0).toFixed(2),
    );
    const grandTotal = dataToRender.reduce((sum, c) => sum + c.clientTotal, 0).toFixed(2);
    rows.push(['', 'Totals', ...monthTotals, grandTotal]);
    triggerCSVDownload(
      headers,
      rows,
      `revenue-forecast-clients-${dayjs().format('YYYY-MM-DD')}.csv`,
    );
  }
};
